import ActionCell from './custom-cells/ActionCell';
import CheckBoxCell from './custom-cells/CheckBoxCell';
import DropDownCell from './custom-cells/DropDownCell';
import EditableDropDownCell from './custom-cells/EditableDropDownCell';
import ZoomTextFieldCell from './custom-cells/ZoomTextFieldCell';
import { MAPPING_SOURCES, REPORT_CONTROL_TYPE } from '../../constants/report-designer.constants';

export const columns = {
  [REPORT_CONTROL_TYPE.FILTER_CONDITION_CONTAINER]: [
    {
      header: '(',
      accessor: 'openGroup',
      customCell: DropDownCell,
      width: 80,
    },
    {
      header: 'Field Name',
      accessor: 'dataField',
      customCell: ZoomTextFieldCell,
      required: true,
      mappingFields: [
        { propertyName: 'dataMember', source: MAPPING_SOURCES.ENTITY_NAME },
        { propertyName: 'label', source: MAPPING_SOURCES.TRANSLATED_ENTITY_FIELD },
        { propertyName: 'dataField', source: MAPPING_SOURCES.ENTITY_FIELD },
      ],
    },
    {
      header: 'Condition',
      accessor: 'condition',
      customCell: DropDownCell,
    },
    {
      header: 'Filter Value',
      accessor: 'value',
      customCell: EditableDropDownCell,
    },
    {
      header: 'Display Current Values',
      accessor: 'showValues',
      customCell: CheckBoxCell,
    },
    {
      header: ')',
      accessor: 'closeGroup',
      customCell: DropDownCell,
      width: 80,
    },
    {
      header: 'And Or',
      accessor: 'operator',
      customCell: DropDownCell,
      width: 80,
    },
    {
      accessor: 'action',
      hasExpandableRow: true,
      customCell: ActionCell,
      width: 60,
    },
  ],

  [REPORT_CONTROL_TYPE.DATA_FILTER_CONDITION_CONTAINER]: [
    {
      header: '(',
      accessor: 'openGroup',
      customCell: DropDownCell,
      width: 80,
    },
    {
      header: 'Field Name',
      accessor: 'dataField',
      customCell: ZoomTextFieldCell,
      required: true,
      mappingFields: [
        { propertyName: 'dataMember', source: MAPPING_SOURCES.ENTITY_NAME },
        { propertyName: 'dataField', source: MAPPING_SOURCES.ENTITY_FIELD },
      ],
    },
    {
      header: 'Condition',
      accessor: 'condition',
      customCell: DropDownCell,
    },
    {
      header: 'Filter Field Name',
      accessor: 'dataFilterField',
      customCell: ZoomTextFieldCell,
      required: true,
      mappingFields: [
        { propertyName: 'dataFilterMember', source: MAPPING_SOURCES.ENTITY_NAME },
        { propertyName: 'dataFilterField', source: MAPPING_SOURCES.ENTITY_FIELD },
      ],
    },
    {
      header: ')',
      accessor: 'closeGroup',
      customCell: DropDownCell,
      width: 80,
    },
    {
      header: 'And Or',
      accessor: 'operator',
      customCell: DropDownCell,
      width: 80,
    },
    {
      accessor: 'action',
      customCell: ActionCell,
      width: 60,
    },
  ],

  [REPORT_CONTROL_TYPE.SORT_CONDITION_CONTAINER]: [
    {
      header: 'Field Name',
      accessor: 'dataField',
      customCell: ZoomTextFieldCell,
      required: true,
      supportExpression: true,
      mappingFields: [
        { propertyName: 'dataMember', source: MAPPING_SOURCES.ENTITY_NAME },
        { propertyName: 'dataField', source: MAPPING_SOURCES.ENTITY_FIELD },
      ],
    },
    {
      header: 'Sort Direction',
      accessor: 'sort',
      customCell: DropDownCell,
    },
    {
      accessor: 'action',
      customCell: ActionCell,
      width: 60,
    },
  ],
};
